import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/solution/building/arrow.png'


const _hoisted_1 = { class: "solution-detail" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "banner" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = {
  key: 0,
  class: "plan"
}
const _hoisted_9 = { class: "plan-content" }
const _hoisted_10 = { class: "left" }
const _hoisted_11 = { class: "plan-intro" }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "custom-value" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "right" }
const _hoisted_16 = { class: "image" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "plan-name" }
const _hoisted_20 = {
  key: 1,
  class: "plan"
}
const _hoisted_21 = { class: "plan-content" }
const _hoisted_22 = { class: "left" }
const _hoisted_23 = { class: "plan-intro" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "plan-intro" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "plan-intro" }
const _hoisted_28 = { class: "content" }
const _hoisted_29 = { class: "right" }
const _hoisted_30 = { class: "image" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "plan-name" }
const _hoisted_34 = { class: "function" }
const _hoisted_35 = {
  key: 0,
  class: "common-title"
}
const _hoisted_36 = {
  key: 1,
  class: "common-title"
}
const _hoisted_37 = { class: "content" }
const _hoisted_38 = { class: "title-list" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "icon" }
const _hoisted_41 = { class: "text" }
const _hoisted_42 = {
  key: 0,
  class: "function-list"
}
const _hoisted_43 = { class: "img" }
const _hoisted_44 = { class: "content" }
const _hoisted_45 = {
  key: 2,
  class: "muster"
}
const _hoisted_46 = { class: "muster-container" }
const _hoisted_47 = { class: "image" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "text" }
const _hoisted_50 = {
  key: 3,
  class: "formation"
}
const _hoisted_51 = { class: "common-title" }
const _hoisted_52 = { class: "text" }
const _hoisted_53 = { class: "formation-list" }
const _hoisted_54 = { class: "image" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "text-container" }
const _hoisted_57 = { class: "title" }
const _hoisted_58 = { class: "content" }
const _hoisted_59 = {
  key: 4,
  class: "function-intro"
}
const _hoisted_60 = { class: "function-intro-list" }
const _hoisted_61 = { class: "container" }
const _hoisted_62 = { class: "image" }
const _hoisted_63 = ["src"]
const _hoisted_64 = { class: "text-container" }
const _hoisted_65 = { class: "title" }
const _hoisted_66 = { class: "content" }
const _hoisted_67 = {
  key: 5,
  class: "school-special"
}
const _hoisted_68 = { class: "special-item" }
const _hoisted_69 = { class: "title" }
const _hoisted_70 = { class: "image" }
const _hoisted_71 = ["src"]
const _hoisted_72 = { class: "image" }
const _hoisted_73 = ["src"]
const _hoisted_74 = { class: "text-container" }
const _hoisted_75 = { class: "title" }
const _hoisted_76 = { class: "content" }
const _hoisted_77 = {
  key: 6,
  class: "technology"
}
const _hoisted_78 = { class: "technology-list" }
const _hoisted_79 = { class: "image" }
const _hoisted_80 = ["src"]
const _hoisted_81 = { class: "text-container" }
const _hoisted_82 = { class: "title" }
const _hoisted_83 = { class: "content" }
const _hoisted_84 = {
  key: 7,
  class: "pay-value"
}
const _hoisted_85 = { class: "pay-value-list" }
const _hoisted_86 = { class: "image" }
const _hoisted_87 = ["src"]
const _hoisted_88 = { class: "text-container" }
const _hoisted_89 = { class: "title" }
const _hoisted_90 = { class: "content" }
const _hoisted_91 = {
  key: 8,
  class: "building-special"
}
const _hoisted_92 = { class: "full-container" }
const _hoisted_93 = { class: "building-special-list" }
const _hoisted_94 = { class: "image" }
const _hoisted_95 = ["src"]
const _hoisted_96 = { class: "text-container" }
const _hoisted_97 = { class: "title" }
const _hoisted_98 = { class: "content" }
const _hoisted_99 = {
  key: 9,
  class: "goodness"
}
const _hoisted_100 = { class: "goodness-list" }
const _hoisted_101 = { class: "icon" }
const _hoisted_102 = { class: "title" }
const _hoisted_103 = { class: "content" }
const _hoisted_104 = { class: "goodness-list" }
const _hoisted_105 = { class: "icon" }
const _hoisted_106 = { class: "title" }
const _hoisted_107 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyHeader = _resolveComponent("MyHeader")!
  const _component_MyBreadCrumb = _resolveComponent("MyBreadCrumb")!
  const _component_icon_svg = _resolveComponent("icon-svg")!
  const _component_MyFooter = _resolveComponent("MyFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MyHeader, { currentMenuIndex: 1 }),
    _createVNode(_component_MyBreadCrumb, {
      listName: "解决方案",
      detailName: _ctx.bannerData.label,
      onReturnList: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('return-list')))
    }, null, 8, ["detailName"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.bannerData.bannerImg,
            alt: ""
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.bannerData.label), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerData.descList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "desc",
              key: index
            }, _toDisplayString(item.content), 1))
          }), 128))
        ])
      ]),
      (JSON.stringify(_ctx.planData) !== '{}')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "common-title" }, [
              _createElementVNode("span", { class: "text" }, "方案架构")
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "方案介绍", -1)),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.planData.planIntro), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title" }, "客户价值", -1)),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.planData.customValue), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("img", {
                    src: _ctx.planData.planImage,
                    alt: ""
                  }, null, 8, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.planData.planName), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "line" }, null, -1))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (JSON.stringify(_ctx.planData2) !== '{}')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "common-title" }, [
              _createElementVNode("span", { class: "text" }, "解决方案")
            ], -1)),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.planData2.planIntro1), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "blue" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.planData2.planIntro2), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "blue" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.planData2.planIntro3), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "blue" }, null, -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("img", {
                    src: _ctx.planData2.planImage,
                    alt: ""
                  }, null, 8, _hoisted_31)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.planData2.planName), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "line" }, null, -1))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_34, [
        (_ctx.currentType === 'building')
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("span", { class: "text" }, "功能场景", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("span", { class: "text" }, "核心功能", -1)
            ]))])),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.functionData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.currentFunctionIndex === index ? 'active title-item' : 'title-item'),
                style: _normalizeStyle(`padding: 0 ${_ctx.functionData.length < 7 ? 30 : 0}px 30px;`),
                key: index,
                onClick: ($event: any) => (_ctx.currentFunctionIndex = index)
              }, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("i", {
                    class: _normalizeClass(`iconfont ${item.icon}`),
                    style: {"font-size":"44px"}
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_41, _toDisplayString(item.title), 1)
              ], 14, _hoisted_39))
            }), 128))
          ]),
          (_ctx.functionData[_ctx.currentFunctionIndex] && _ctx.functionData[_ctx.currentFunctionIndex].childrenList)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.functionData[_ctx.currentFunctionIndex].childrenList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "function-item",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_icon_svg, {
                        "icon-class": item.svg
                      }, null, 8, ["icon-class"])
                    ]),
                    _createElementVNode("div", _hoisted_44, _toDisplayString(item.content), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (JSON.stringify(_ctx.musterData) !== '{}')
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "common-title" }, [
              _createElementVNode("span", { class: "text" }, "五位一体")
            ], -1)),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("img", {
                  src: _ctx.musterData.img,
                  alt: ""
                }, null, 8, _hoisted_48)
              ]),
              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.musterData.text), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (JSON.stringify(_ctx.formationData) !== '{}')
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.formationData.title), 1)
            ]),
            _createElementVNode("div", _hoisted_53, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formationData.childrenList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "formation-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("img", {
                      src: item.img,
                      alt: ""
                    }, null, 8, _hoisted_55)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_58, _toDisplayString(item.content), 1)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.introData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "common-title" }, [
              _createElementVNode("span", { class: "text" }, "功能介绍")
            ], -1)),
            _createElementVNode("div", _hoisted_60, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.introData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "function-intro-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("img", {
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_63)
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_66, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (item2, index2) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "text",
                            key: index2
                          }, _toDisplayString(item2), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (JSON.stringify(_ctx.specialData) !== '{}')
        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.specialData.title), 1),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("img", {
                  src: _ctx.specialData.img,
                  alt: ""
                }, null, 8, _hoisted_71)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialData.childrenList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "children-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("img", {
                    src: item.img,
                    alt: ""
                  }, null, 8, _hoisted_73)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_76, _toDisplayString(item.content), 1)
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "triangle" }, null, -1))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.technologyData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "common-title" }, [
              _createElementVNode("span", { class: "text" }, "技术特点")
            ], -1)),
            _createElementVNode("div", _hoisted_78, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.technologyData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "technology-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("img", {
                      src: item.img,
                      alt: ""
                    }, null, 8, _hoisted_80)
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_83, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (item2, index2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "text",
                          key: index2
                        }, _toDisplayString(item2), 1))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.payValueData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "common-title" }, [
              _createElementVNode("span", { class: "text" }, "交付价值")
            ], -1)),
            _createElementVNode("div", _hoisted_85, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payValueData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "pay-value-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("img", {
                      src: item.img,
                      alt: ""
                    }, null, 8, _hoisted_87)
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_90, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (item2, index2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "text",
                          key: index2
                        }, _toDisplayString(item2), 1))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.unifyData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "common-title" }, [
              _createElementVNode("span", { class: "text" }, "六大统一")
            ], -1)),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unifyData, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "building-special-item",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("img", {
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_95)
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("span", _hoisted_97, _toDisplayString(item.title), 1),
                      _createElementVNode("span", _hoisted_98, _toDisplayString(item.content), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "dot" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                })
              ], -1))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.goodnessData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "common-title" }, [
              _createElementVNode("span", { class: "text" }, "优势特点")
            ], -1)),
            _createElementVNode("div", _hoisted_100, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodnessData.filter((item, index) => index < Math.floor(_ctx.goodnessData.length / 2)), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "goodness-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`iconfont ${item.icon}`),
                      style: {"font-size":"34px"}
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_102, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_103, _toDisplayString(item.content), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_104, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodnessData.filter((item, index) => index >= Math.floor(_ctx.goodnessData.length / 2)), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "goodness-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`iconfont ${item.icon}`),
                      style: {"font-size":"34px"}
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_106, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_107, _toDisplayString(item.content), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_MyFooter)
    ])
  ]))
}